import { useEffect, useState } from 'react';

/** `true` assim que a página passa de `limiar` pixels de scroll vertical. */
export function useScrolled(limiar = 24): boolean {
  const [rolado, setRolado] = useState(false);

  useEffect(() => {
    function medir(): void {
      setRolado(window.scrollY > limiar);
    }
    medir();
    window.addEventListener('scroll', medir, { passive: true });
    return () => window.removeEventListener('scroll', medir);
  }, [limiar]);

  return rolado;
}
